import Cookies from 'js-cookie';

export const logout = () => {
  Cookies.remove('__user')
}

export const getUser = () => {
  return Cookies.get('__user');
}

export const isLogin = () => {
  return Cookies.get('__user');
}

export const toDateFormat = (d) => {
  if (d) {
    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
  } else {
    return '';
  }
}

export const toNumber = (s) => {
  if (s) {
    if (isNaN(s)) {
      let n = s.replaceAll(' ', '');
      return parseInt(n);
    } else {
      return s;
    }
  } else {
    return '';
  }
}

export const formatBankAccountNumber = (s) => {
  if (s) {
    let e = insert(insert(insert(insert(s, ' ', 4), ' ', 9), ' ', 11), ' ', 16);
    if (s.length > 20) {
      let x = insert(insert(insert(e, ' ', 21), ' ', 23), ' ', 28);
      return x;
    }
    return e;
  } else {
    return '';
  }
}

const insert = (s, c, p) => {
  return [s.slice(0, p), c, s.slice(p)].join('');
}

export const trimSpaces = (s) => {
  if (s || s === 0) {
    if (typeof (s) === 'string') {
      let n = s.replaceAll(' ', '');
      return n;
    } else {
      let n = s.toString().replaceAll(' ', '');
      return n;
    }
  } else {
    return '';
  }
}

export const toThousands = (s) => {
  return s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const saveToLocalStorage = (tableName, type, value) => {
  const table = localStorage.getItem(tableName);
  const tableObj = JSON.parse(table);
  if (tableObj) {
    tableObj[type] = value;
    localStorage.setItem(tableName, JSON.stringify(tableObj));
  } else {
    const newTableObj = {};
    newTableObj[type] = value;
    localStorage.setItem(tableName, JSON.stringify(newTableObj));
  }

}

export const getFromLocalStorage = (tableName, type) => {
  const table = localStorage.getItem(tableName);
  const tableObj = JSON.parse(table);
  if (tableObj) {
    return tableObj[type];
  } else {
    return '';
  }
}

export const fmt = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString(); // use user's locale
};

